import cookie from "react-cookies";
import moment from "moment";
import { PUBLIC_KEY } from "../GlobalVariables/GlobalVariables";
//import { message } from "antd";
import { userConstants } from ".././constants/ActionTypes";
import {
  Wallet,
  Calendar,
  FileText,
  Users,
  CreditCard,
  UploadCloud,
  Link,
  Download,
  Send,
  LayoutDashboard,
  Building,
} from "lucide-react";
export default function getAuthToken() {
  var token = cookie.load("AuthAdmin", { path: "/" });
  return token;
}
export function showZoneDate(date) {
  if (date === "" || date === undefined || date === null || date === "-") {
    return "";
  }
  var date = moment(date);
  return moment.utc(date).format("DD/MM/YYYY");
}
export function getCookie(key) {
  var token = cookie.load(key, { path: "/" });
  return token;
}
export function setCookie(key, value) {
  cookie.save(key, value, {
    path: "/",
    maxAge: 19900000,
    secure: false,
  });
}
export let deleteAllCookies = function deleteAllCookies() {
  var cookies = document.cookie.split(";");
  for (var i = 0; i < cookies.length; i++) {
    var cookie = cookies[i];
    var eqPos = cookie.indexOf("=");
    var name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
    document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
  }
};
export let sessionStorageSetItem = function sessionStorageSetItem(key, value) {
  if (typeof value == Object) {
    return window.sessionStorage.setItem(key, JSON.stringify(value));
  } else {
    return window.sessionStorage.setItem(key, value);
  }
};
export let sessionStorageGetItem = function sessionStorageGetItem(key) {
  if (typeof value == Object) {
    return JSON.parse(window.sessionStorage.getItem(key));
  } else {
    return window.sessionStorage.getItem(key);
  }
};
export let sessionStorageRemoveItem = function sessionStorageRemoveItem(key) {
  return window.sessionStorage.removeItem(key);
};
export let sessionStorageRemoveAll = function sessionStorageRemoveAll() {
  return window.sessionStorage.clear();
};
export function currencyFormatter(amount, code) {
  return new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: code.code,
  }).format(amount);
}

export function saveUserShowHome(response, from_where) {
  if (response.success) {
    if (from_where === "from_signin") {
      var data = response.data;

      sessionStorageSetItem("MerchantAuthPayout", data.authorization);
      sessionStorageSetItem("auth_merchant_id", data.merchantId);
      window.location.href = "/dashboard";
    } else if (
      from_where === "from_otp" ||
      from_where === "from_secure-signin"
    ) {
      var data = response.data;
      sessionStorageSetItem("MerchantAuthPayout", data.authorization);
      sessionStorageSetItem("auth_merchant_id", data.merchantId);
      //self.props.history.push("/dashboard");
      window.location.href = "/dashboard";
    }
  }
}

export function getAWSLink() {
  return "http://localhost/api/v1/s3/sign";
}

export function randomString(len) {
  var charSet =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  var randomString = "";
  for (var i = 0; i < len; i++) {
    var randomPoz = Math.floor(Math.random() * charSet.length);
    randomString += charSet.substring(randomPoz, randomPoz + 1);
  }
  return randomString;
}

export function GET_AWS_LINK(result) {
  //return `https://ippostack.s3.amazonaws.com/${cookie.load("auth_merchant_id")}/${result.filename}`;
  return "https://ippo-pay.s3.amazonaws.com/" + result.filename;
}

export function returnTimeZoneDate(date) {
  if (date === "" || date === undefined || date === null || date === "-") {
    return "";
  }
  var date = moment(date);
  return moment.utc(date).local().format("DD-MM-YYYY h:mm a");
}

export function returnZoneDate(date) {
  if (date === "" || date === undefined || date === null || date === "-") {
    return "";
  }
  var date = moment(date);
  return moment.utc(date).local().format("DD/MM/YYYY");
}

export function textCapitalize(data) {
  if (data !== undefined && data !== null && data !== "") {
    return data.charAt(0).toUpperCase() + data.slice(1);
  } else {
    return data;
  }
}

export const removeUnderScore = (value) => {
  return value
    ?.replaceAll("-", " ")
    ?.replaceAll("_", " ")
    ?.replaceAll("?", " for ")
    ?.replaceAll(" ", " ")
    ?.replaceAll(".", " ")
    ?.replaceAll("%20", " ")
    ?.replace(/(\b)kyc(\b)/g, "KYC")
    ?.replace(/(\b)ip(\b)/g, "IP")
    ?.replace(/(\b)ndr(\b)/g, "NDR")
    ?.replace(/(\b)api(\b)/g, "API")
    ?.replace(/(\b)dr(\b)/g, "DR")
    ?.replace(/(\b)nda(\b)/g, "NDA");
};

export function checkImageType(
  self,
  name,
  is_name,
  file,
  next,
  progress,
  isFrom
) {
  var imageType = "image/*";
  if (!file.type.match(imageType)) {
    //message.error("Please upload image only");
  } else {
    if (isFrom === "international") {
      self.onUploadPrimaryStart(file, next, name, is_name, progress);
    } else {
      self.onUploadPrimaryStart(file, next, name);
    }
  }
}

export function validate(e) {
  var theEvent = e || window.event;
  if (theEvent.type === "paste") {
    key = e.clipboardData.getData("text/plain");
  } else {
    var key = theEvent.keyCode || theEvent.which;
    key = String.fromCharCode(key);
  }
  var regex = /^[0-9]+$/;
  if (!regex.test(key)) {
    theEvent.returnValue = false;
    if (theEvent.preventDefault) theEvent.preventDefault();
  }
}

export function manipulateString(str) {
  var i,
    frags = str.split("_");
  for (i = 0; i < frags.length; i++) {
    frags[i] = frags[i].charAt(0).toUpperCase() + frags[i].slice(1);
  }
  return frags.join("");
}

export function preprocess(file, next, key, updateState, dispatch, applyToast) {
  var imageType = "image/*";
  var reader = new FileReader();
  if (!file.type.match(imageType)) {
    applyToast("Please upload image only", "error");
  } else if (!(file.size / 5120 / 5120 < 5)) {
    applyToast("Image size should be less than 5 mb", "error");
  } else {
    reader.onload = function (e) {};
    reader.readAsDataURL(file);
    next(file);
    dispatch(updateState(userConstants.HEADER, { [key]: true }));
  }
}

export function onError(key, updateState, dispatch, applyToast) {
  dispatch(updateState(userConstants.HEADER, { [key]: false })).then(() => {
    applyToast("Image Upload failure please try again", "error");
  });
}

export function onFinish(url, key1, key2, updateState, dispatch, applyToast) {
  var image = GET_AWS_LINK(url);
  dispatch(
    updateState(userConstants.HEADER, { [key1]: image, [key2]: false })
  ).then(() => {
    applyToast("Image Uploaded Successfully", "success");
  });
}

export function removeImage(key1, key2, updateState, dispatch) {
  dispatch(updateState(userConstants.HEADER, { [key1]: "", [key2]: false }));
}

export function returnFixed(value) {
  var priceRegex = /[\d]+\.[\d]+/;
  if (priceRegex.test(value)) {
    var price = parseFloat(value);
    return price;
  } else if (value === "" || isNaN(value)) {
    return 0;
  } else {
    var price = parseFloat(value);
    var newPrice =
      "" +
      Math.round(price * 100) / 100 +
      (value.indexOf(".") === value.length - 1 ? "." : "");
    return newPrice;
  }
}

export function handleUpiVpa(id) {
  var upiresilt = /^[\w.-]+@[\w.-]+$/.test(id);
  if (upiresilt) {
    return true;
  }
  return false;
}
export function escape(str) {
  var tagsToReplace = {
    // '&': '&amp;',
    "<": "&lt;",
    ">": "&gt;",
  };
  return str.replace(/[<>]/g, function (tag) {
    return tagsToReplace[tag] || tag;
  });
}
export const tutelar = new window.Tutelar({ public_key: PUBLIC_KEY });

export function splitWords(input) {
  return input.split(/[-_]/).join(" ");
}

export function formatLabel(str) {
  return str
    .replace(/_/g, " ")
    .toLowerCase()
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
}
export function formatLabelWithCaps(text) {
  return text.replace(/_/g, " ").replace(/\b\w/g, (char) => char.toUpperCase()); // Capitalize first letter of each word
}
export function camelCaseText(value) {
  return value.replace(/([a-z])([A-Z])/g, "$1 $2");
}
export const getLinkPath = (displayName) => {
  // Convert "User Management" to "/user-management"
  switch (displayName) {
    case "Payouts":
      return "/payouts";
    case "Scheduled Payouts":
      return "/schedule-payment";
    case "Account Statement":
      return "/transaction";
    case "Dashboard":
      return "/dashboard";
    case "Contacts":
      return "/contacts";
    case "Accounts":
      return "/accounts";
    case "Bulk Upload":
      return "/bulkupload";
    case "Payout Links":
      return "/payoutlink";
    case "Download Manager":
      return "/report-list";
    case "Payout request":
      return "/payout-request";

    default:
      return "/dashboard";
  }
};

export const getIconForRoute = (group) => {
  switch (group) {
    case "merchant-payouts":
      return <Wallet className="w-5 h-5" />;
    case "merchant-scheduled-payouts":
      return <Calendar className="w-5 h-5" />;
    case "merchant-account-statement":
      return <FileText className="w-5 h-5" />;
    case "merchant-contacts":
      return <Users className="w-5 h-5" />;
    case "merchant-bulk-upload":
      return <UploadCloud className="w-5 h-5" />;
    case "merchant-payout-link":
      return <Link className="w-5 h-5" />;
    case "merchant-accounts":
      return <CreditCard className="w-5 h-5" />;
    case "merchant-download-manager":
      return <Download className="w-5 h-5" />;
    case "merchant-payout-request":
      return <Send className="w-5 h-5" />;
    case "merchant-home":
      return <LayoutDashboard className="w-5 h-5" />;
    default:
      return <Building className="w-5 h-5" />;
  }
};

export const getDescription = (displayName) => {
  switch (displayName) {
    case "merchant-payouts":
      return "Do instant payout to users, customers, and vendors";
    case "merchant-scheduled-payouts":
      return "Automate future payments by setting dates in advance";
    case "merchant-account-statement":
      return "Download your transaction details and reports";
    case "merchant-contacts":
      return "Manage your beneficiaries and fund account details";
    case "merchant-accounts":
      return "Create and collect money to your virtual accounts";
    case "merchant-bulk-upload":
      return "Send Bulk Payouts with simple Excel sheet upload";
    case "merchant-payout-link":
      return "Make payouts without collecting fund account details";
    case "merchant-download-manager":
      return "Download your Transaction and other Reports";
    case "merchant-payout-request":
      return "Use the payout request module to Approve or Reject fund transfer";
    default:
      return "";
  }
};

// Utility: ensure unique options by value
export const uniqByValue = (arr) => {
  const seen = new Set();
  return (arr || []).filter((o) => {
    const id = o && o.value;
    if (!id || seen.has(id)) return false;
    seen.add(id);
    return true;
  });
};

export const checkValue = (val) => {
  const value = val === "" || val === undefined || val === null;
  return value ? "-" : val;
};

export const CheckfileType = (type) => {
  return ["image/png", "image/jpeg", "application/pdf"].includes(type);
};
export const capitalizeFirstLetter = (text) => {
  if (!text) return "";
  return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
};

export const showTransactionStatus = (status) => {
  const text = status?.toLowerCase();
  switch (text) {
    case "accepted":
    case "approved":
      return "label label-info label-sm accepted";
    case "queued":
      return "label label-default label-sm queued";
    case "processing":
      return "label label-primary label-sm processing";
    case "success":
      return "label label-success label-sm success";
    case "failed":
    case "rejected":
      return "label label-danger label-sm failed";
    case "cancelled":
      return "label label-warning label-sm cancelled";
    case "pending":
      return "label cancelled_trans label-sm failedd";
    case "initiated":
      return "label label-sm initiated";

    default:
      return "";
  }
};
